import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=87151b2e&scoped=true&"
import script from "./BaseSearch.vue?vue&type=script&lang=js&"
export * from "./BaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearch.vue?vue&type=style&index=0&id=87151b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87151b2e",
  null
  
)

export default component.exports